import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TsButtonModule, TsButtonVariant } from 'tsui';
import { TsBaseDialog, TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

export interface ConfirmationDialogData {
  dialogTitle: string;
  description: string;
  renderHtml: boolean;
  errorMessage?: string;
  styling?: {
    yes: TsButtonVariant;
  };
  buttonsConfig: {
    yes: string;
    no: string;
  };
}

@Component({
  selector: 'confirmation-dialog',
  standalone: true,
  imports: [TsButtonModule, TsDialogComponent],
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent implements TsBaseDialog<boolean> {
  protected dialogRef = inject(DialogRef);
  protected dialogData = inject<ConfirmationDialogData>(DIALOG_DATA);

  get title(): string {
    return this.dialogData?.dialogTitle || 'Confirmation';
  }

  get renderHtml(): boolean {
    return this.dialogData?.renderHtml || false;
  }

  get description(): string {
    return this.dialogData?.description || 'Are you sure?';
  }

  get errorMessage(): string | undefined {
    return this.dialogData?.errorMessage;
  }

  get hasError(): boolean {
    return !!this.dialogData?.errorMessage;
  }

  get yesLabel(): string {
    return this.dialogData?.buttonsConfig?.yes || 'Yes';
  }

  get yesStylingVariant(): TsButtonVariant {
    return this.dialogData?.styling?.yes || 'danger';
  }

  get noLabel(): string {
    return this.dialogData?.buttonsConfig?.no || 'No';
  }

  /**
   * Dismiss the dialog (e.g. via the header "X").
   */
  dismiss(): void {
    this.dialogRef.close();
  }

  /**
   * Explicit negative action ("No"/"Cancel").
   */
  cancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Explicit positive action ("Yes"/"Confirm").
   */
  confirm(): void {
    this.dialogRef.close(true);
  }

  closeDialog(result: boolean): void {
    this.dialogRef.close(result);
  }
}
